import { render } from "./FormDateFieldComponent.vue?vue&type=template&id=085324a0"
import script from "./FormDateFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormDateFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__